import React from 'react';
import { Tag as TagBase } from 'rsuite';

import * as style from './tag.module.less';

const Tag = (props) => {
  const {
    size,
    children,
  } = props;
  // Tags share one neutral style; per-tag colours made the page too busy.
  return (
    <TagBase size={size} className={style.tag}>
      {children}
    </TagBase>
  );
};

export default Tag;
